import {useAppBridge} from "@shopify/app-bridge-react";
import { Frame, Page } from "@shopify/polaris";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Api from "../../helpers/api";
import CustomerForm from "./Form";

const EditCustomer = props => {
    const app = useAppBridge();
    const history = useHistory();
    const {customerId} = useParams();
    const [customer, setCustomer] = useState(null);

    useEffect(() => {
        Api.getCustomer(customerId).then( response => setCustomer( response.data.data) );
    }, []);

    return customer && (
        <Frame>
            <Page title={`Edit customer ${customer.account_number}`} backAction={{ content: 'Customer', onAction: () => { history.goBack()} }}>
                <CustomerForm customer={customer} updating={true} onCustomerCreated={updatedCustomer => {
                    app.toast.show('Customer was updated', { duration: 3000 });

                    setCustomer(customer);
                }} />
            </Page>
        </Frame>
    );
}

export default EditCustomer;
